<template>
  <Form @submit="handleFormSend" :validation-schema="formValidationSchema" ref="fileUploadForm" autocomplete="off">

    <div class="create-cert-field mb-4">
      <label class="create-cert-label">{{ $t('cert.certName') }}</label>
      <Field
          class="create-cert-input"
          v-model="name"
          type="text"
          id="name"
          name="name"
          :placeholder="$t('cert.certName')"
          :label="$t('cert.certName')"
      />
      <ErrorMessage class="create-cert-error" name="name" />
    </div>

    <div class="create-cert-field mb-4">
      <!-- Pole pro výběr nebo přetažení souboru — bez záhlaví -->
      <Field name="file" v-slot="{ handleChange, handleBlur }">
        <div
            class="create-cert-dropzone"
            :class="{ 'create-cert-dropzone--active': isDragging, 'create-cert-dropzone--filled': file }"
            @dragover.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop.prevent="onDrop"
            @click="$refs.files.click()"
        >
          <img :src="iconFile" alt="" class="create-cert-dropzone__icon">
          <span v-if="!file" class="create-cert-dropzone__text">
            {{ $t('cert.uploadFile') }}
          </span>
          <span v-else class="create-cert-dropzone__filename">{{ file.name }}</span>
          <input
              type="file"
              name="file"
              id="file"
              ref="files"
              style="display: none"
              @change="handleChange, onFileChanged($event)"
              @blur="handleBlur"
          />
        </div>
      </Field>
      <ErrorMessage class="create-cert-error" name="file" />
      <p class="create-cert-hint mt-2">{{ $t('cert.maxFileSizeText') }}</p>
      <p class="create-cert-hint">{{ $t('cert.afterCreatingNotPossibleChange') }}</p>
    </div>

    <div class="d-flex justify-content-end gap-3 mt-2">
      <button type="button" class="btn create-cert-btn-cancel" @click="$emit('close')">
        {{ $t('general.cancel') }}
      </button>
      <button type="submit" class="btn btn-primary create-cert-btn-submit" :disabled="uploading">
        <span v-if="uploading" class="spinner-border spinner-border-sm me-2" role="status"></span>
        {{ uploading ? $t('cert.processing') : $t('cert.certCreate') }}
      </button>
    </div>

  </Form>
</template>

<script>
import http from '@/http';
import iconFile from '/public/img/new-design/icons/file.svg';
import VuePdfEmbed from 'vue-pdf-embed';

export default {
  emits: ['close', 'certCreated'],

  data() {
    return {
      name: null,
      file: null,
      previewBase64: null,
      previewPromise: null,
      isDragging: false,
      uploading: false,
      iconFile,
      formValidationSchema: {
        name: 'required',
      },
    };
  },

  methods: {
    onDrop(event) {
      this.isDragging = false;
      const dropped = event.dataTransfer.files[0];
      if (dropped) this.setFile(dropped);
    },

    onFileChanged(event) {
      const selected = this.$refs.files.files[0];
      if (selected) this.setFile(selected);
    },

    setFile(f) {
      if (f.size > 31.2 * 1024 * 1024) {
        alert('Soubor je příliš velký. Maximální velikost je 32 MB.');
        return;
      }
      this.file = f;
      this.previewBase64 = null;
      this.previewPromise = null;

      if (f.type === 'application/pdf') {
        this.previewPromise = this.generatePdfPreview(f);
      }
    },

    async generatePdfPreview(file) {
      try {
        const arrayBuffer = await file.arrayBuffer();
        const pdf = await VuePdfEmbed.getDocument({ data: arrayBuffer }).promise;
        const page = await pdf.getPage(1);

        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
        const result = canvas.toDataURL('image/png');
        this.previewBase64 = result;
        return result;
      } catch (e) {
        this.previewBase64 = null;
        return null;
      }
    },

    async uploadFile() {
      const file = this.file;
      const name = this.name;

      let previewBase64 = null;
      if (this.previewPromise) {
        previewBase64 = await this.previewPromise;
      }

      const body = new FormData();
      body.append('name', name);
      body.append('file', file);
      if (previewBase64) {
        body.append('preview_base64', previewBase64);
      }

      this.uploading = true;
      http.post('/certs/create', body).then((response) => {
        this.emitter.emit('certAdded', response.data.cert);
        if (window.updateCreditCount) window.updateCreditCount();
        this.uploading = false;
        this.file = null;
        this.previewBase64 = null;
        this.$refs.fileUploadForm?.resetForm();
        document.getElementById('file').value = null;
        this.$emit('certCreated', response.data.cert);
        this.$router.push({ name: 'CertDetail', params: { uuid: response.data.cert.uuid } });
      }).catch(() => {
        this.uploading = false;
      });
    },

    handleFormSend() {
      this.uploadFile();
    },
  },
};
</script>